import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { from } from 'rxjs';
import { URLSearchParams } from 'url';


/** This class implements some features that should be tested. */
@Injectable()
export class HttpClientAuthServiceService {

  constructor(
    private http: HttpClient
  ) {}

  async login() {

    let hoursDiffer = new Date().getHours() - Number(localStorage.getItem('refreshDate'));

    /*if (new Date().getHours() == Number(localStorage.getItem('refreshDate'))
     && localStorage.hasOwnProperty('refreshDate'))
    {
        return;
    }*/

    var axios = require('axios');
    var qs = require('qs');
    var data = qs.stringify({
     'username': 'webservicepagina',
    'password': 'w3bs3rv1c3p4g1n4',
    'grant_type': 'password'
    });
    var config = {
      method: 'post',
      url: 'https://www.mundofinanciera.com:9091/api/oauth/token',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Basic TXVuZG9GaW5hbmNpZXJhOk1GMjAyMCo='
      },
      data : data
    };

    axios(config)
    .then(function (response) {(
      localStorage.setItem('tokenId',JSON.stringify(response.data['access_token']).replace('"','').replace('"','')));
      localStorage.setItem('refreshDate',new Date().getHours().toString());
      //return  JSON.stringify(response.data);
    })
    .catch(function (error) {
      console.log(error);
    });
  }

}
